var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDishes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3983_6078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9466 28.0107C56.0959 31.5733 55.8061 35.1406 55.0836 38.6324C53.1099 47.9504 47.1335 53.9451 36.9525 55.2488C30.2363 56.2373 23.398 56.0259 16.7558 54.6245C13.7989 54.038 11.0349 52.7236 8.71381 50.8001C6.39277 48.8765 4.58795 46.4047 3.46264 43.6081C1.76166 39.4785 0.915334 35.047 0.974774 30.5812C0.784157 26.321 1.07363 22.0528 1.83772 17.8573C3.80231 9.13596 8.19969 4.28875 17.123 2.14055C24.5826 0.332055 32.3663 0.332055 39.8259 2.14055C48.7676 4.28875 53.1925 9.15432 55.0836 17.8481C55.8334 21.1804 56.1238 24.5997 55.9466 28.0107Z",
    fill: "#FBD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3894 19.2461H29.2323C29.6047 19.2461 29.9038 18.9406 29.9038 18.5762C29.9038 18.2053 29.6047 17.9062 29.2323 17.9062H27.3894C27.017 17.9062 26.7179 18.2053 26.7179 18.5762C26.7179 18.9406 27.0164 19.2461 27.3894 19.2461ZM28.3105 21.5241C21.4282 21.5241 15.8033 27.2589 15.4676 34.4403H41.1535C40.8178 27.2584 35.1929 21.5241 28.3105 21.5241ZM13.9668 35.7738L16.4435 37.4605C16.9381 37.801 17.9081 38.0938 18.5122 38.0938H38.1095C38.7135 38.0938 39.6835 37.801 40.1781 37.4605L42.6543 35.7738H13.9668Z",
    fill: "#AB3BBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3983_6078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishes);
export default __webpack_public_path__ + "static/media/Dishes.1195641448bf106830371de344eb8358.svg";
export { ForwardRef as ReactComponent };